<template>
    <div class="home">
        <MainBanner />
        <Welcome />
        <WhyChooseUs />
        <OurServices />
        <WhatOurCustomerSays />
        <Form />
        <Footer />
    </div>
</template>

<script>
    // @ is an alias to /src
    import MainBanner from '@/components/MainBanner.vue'
    import Welcome from '@/components/Welcome.vue'
    import WhatOurCustomerSays from '@/components/WhatOurCustomerSays.vue'
    import Form from '@/components/Form.vue'
    import OurServices from '@/components/OurServices.vue'
    import Footer from '@/components/Footer.vue'
    import WhyChooseUs from '@/components/WhyChooseUs.vue'

    export default {
        name: 'Home',
        components: {
            MainBanner,
            Footer,
            WhyChooseUs,
            Welcome,
            WhatOurCustomerSays,
            Form,
            OurServices
        }
    }
</script>
